export default __webpack_public_path__ + "static/media/prospect2.04167bf5.jpg";